import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ProductMeasurementUpsertState extends ApiState {
  productMeasurementId?: string
}

export default requestReducer<ProductMeasurementUpsertState>('PRODUCTMEASUREMENT_UPSERT')
